// Backend answers a machine owned by another retailer with 403 and an unknown one with 404.
const NOT_OWNED_STATUSES = [403, 404]

// Wraps the global beforeEach's next() for routes that declare `meta.machineOwnership` (a service with getStatus).
// It runs from beforeEach rather than a route's beforeEnter, because beforeEnter is skipped when only :machineId
// changes and the page would then be reused for a machine the retailer does not own.
export default function retailerMachineOwnership(routeTo, routeFrom, next) {
  return (...navigationParams) => {
    const machineService = routeTo.meta.machineOwnership

    if (navigationParams.length > 0 || !machineService) {
      next(...navigationParams)
      return
    }

    // Moving between pages of a machine that already passed the check. Switching the active retailer
    // reloads the panel, so ownership cannot change without a fresh entry.
    const isSameMachine =
      routeFrom.params.machineId === routeTo.params.machineId && routeFrom.meta.machineOwnership === machineService

    if (isSameMachine) {
      next()
      return
    }

    machineService
      .getStatus(routeTo.params.machineId)
      .then(() => next())
      .catch(err => {
        if (NOT_OWNED_STATUSES.includes(err.response?.status)) {
          next({ name: 'retailer.404' })
          return
        }

        next()
      })
  }
}
